import { useRef } from 'react';
export const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
        var _a;
        (_a = htmlElRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return [htmlElRef, setFocus];
};
//# sourceMappingURL=useFocus.js.map